export { default as LinkSolidIcon } from './LinkSolidIcon';
